import { Result } from '@standardnotes/domain-core';
export class GetAuthenticatorAuthenticationResponse {
    constructor(getAuthenticatorAuthenticationOptions, authenticatorVerificationPromptFunction) {
        this.getAuthenticatorAuthenticationOptions = getAuthenticatorAuthenticationOptions;
        this.authenticatorVerificationPromptFunction = authenticatorVerificationPromptFunction;
    }
    async execute(dto) {
        if (!this.authenticatorVerificationPromptFunction) {
            return Result.fail('Could not generate authenticator authentication options: No authenticator verification prompt function provided');
        }
        const authenticationOptionsOrError = await this.getAuthenticatorAuthenticationOptions.execute({
            username: dto.username,
        });
        if (authenticationOptionsOrError.isFailed()) {
            return Result.fail(authenticationOptionsOrError.getError());
        }
        const authenticationOptions = authenticationOptionsOrError.getValue();
        let authenticatorResponse;
        try {
            authenticatorResponse = await this.authenticatorVerificationPromptFunction(authenticationOptions);
        }
        catch (error) {
            return Result.fail(`Could not generate authenticator authentication options: ${error.message}`);
        }
        return Result.ok(authenticatorResponse);
    }
}
